/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as StayInTheLoopRouteImport } from './routes/stay-in-the-loop'
import { Route as SecurityAddendumRouteImport } from './routes/security-addendum'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as EvaluationTermsRouteImport } from './routes/evaluation-terms'
import { Route as DataTransferAddendumRouteImport } from './routes/data-transfer-addendum'
import { Route as DataProcessingAddendumRouteImport } from './routes/data-processing-addendum'
import { Route as CoosRouteImport } from './routes/coos'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as ContactSalesRouteImport } from './routes/contact-sales'
import { Route as CfosRouteImport } from './routes/cfos'
import { Route as CeosRouteImport } from './routes/ceos'
import { Route as CdosRouteImport } from './routes/cdos'
import { Route as AcceptableUsePolicyRouteImport } from './routes/acceptable-use-policy'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResourcesSlugRouteImport } from './routes/resources_.$slug'
import { Route as LandingPagesSlugRouteImport } from './routes/landing-pages.$slug'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const StayInTheLoopRoute = StayInTheLoopRouteImport.update({
  id: '/stay-in-the-loop',
  path: '/stay-in-the-loop',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityAddendumRoute = SecurityAddendumRouteImport.update({
  id: '/security-addendum',
  path: '/security-addendum',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesRoute = ResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerRoute = PartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationTermsRoute = EvaluationTermsRouteImport.update({
  id: '/evaluation-terms',
  path: '/evaluation-terms',
  getParentRoute: () => rootRouteImport,
} as any)
const DataTransferAddendumRoute = DataTransferAddendumRouteImport.update({
  id: '/data-transfer-addendum',
  path: '/data-transfer-addendum',
  getParentRoute: () => rootRouteImport,
} as any)
const DataProcessingAddendumRoute = DataProcessingAddendumRouteImport.update({
  id: '/data-processing-addendum',
  path: '/data-processing-addendum',
  getParentRoute: () => rootRouteImport,
} as any)
const CoosRoute = CoosRouteImport.update({
  id: '/coos',
  path: '/coos',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactSalesRoute = ContactSalesRouteImport.update({
  id: '/contact-sales',
  path: '/contact-sales',
  getParentRoute: () => rootRouteImport,
} as any)
const CfosRoute = CfosRouteImport.update({
  id: '/cfos',
  path: '/cfos',
  getParentRoute: () => rootRouteImport,
} as any)
const CeosRoute = CeosRouteImport.update({
  id: '/ceos',
  path: '/ceos',
  getParentRoute: () => rootRouteImport,
} as any)
const CdosRoute = CdosRouteImport.update({
  id: '/cdos',
  path: '/cdos',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptableUsePolicyRoute = AcceptableUsePolicyRouteImport.update({
  id: '/acceptable-use-policy',
  path: '/acceptable-use-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutUsRoute = AboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
  id: '/resources_/$slug',
  path: '/resources/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingPagesSlugRoute = LandingPagesSlugRouteImport.update({
  id: '/landing-pages/$slug',
  path: '/landing-pages/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about-us': typeof AboutUsRoute
  '/acceptable-use-policy': typeof AcceptableUsePolicyRoute
  '/cdos': typeof CdosRoute
  '/ceos': typeof CeosRoute
  '/cfos': typeof CfosRoute
  '/contact-sales': typeof ContactSalesRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/coos': typeof CoosRoute
  '/data-processing-addendum': typeof DataProcessingAddendumRoute
  '/data-transfer-addendum': typeof DataTransferAddendumRoute
  '/evaluation-terms': typeof EvaluationTermsRoute
  '/partner': typeof PartnerRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/resources': typeof ResourcesRoute
  '/security-addendum': typeof SecurityAddendumRoute
  '/stay-in-the-loop': typeof StayInTheLoopRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/landing-pages/$slug': typeof LandingPagesSlugRoute
  '/resources/$slug': typeof ResourcesSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about-us': typeof AboutUsRoute
  '/acceptable-use-policy': typeof AcceptableUsePolicyRoute
  '/cdos': typeof CdosRoute
  '/ceos': typeof CeosRoute
  '/cfos': typeof CfosRoute
  '/contact-sales': typeof ContactSalesRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/coos': typeof CoosRoute
  '/data-processing-addendum': typeof DataProcessingAddendumRoute
  '/data-transfer-addendum': typeof DataTransferAddendumRoute
  '/evaluation-terms': typeof EvaluationTermsRoute
  '/partner': typeof PartnerRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/resources': typeof ResourcesRoute
  '/security-addendum': typeof SecurityAddendumRoute
  '/stay-in-the-loop': typeof StayInTheLoopRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/landing-pages/$slug': typeof LandingPagesSlugRoute
  '/resources/$slug': typeof ResourcesSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about-us': typeof AboutUsRoute
  '/acceptable-use-policy': typeof AcceptableUsePolicyRoute
  '/cdos': typeof CdosRoute
  '/ceos': typeof CeosRoute
  '/cfos': typeof CfosRoute
  '/contact-sales': typeof ContactSalesRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/coos': typeof CoosRoute
  '/data-processing-addendum': typeof DataProcessingAddendumRoute
  '/data-transfer-addendum': typeof DataTransferAddendumRoute
  '/evaluation-terms': typeof EvaluationTermsRoute
  '/partner': typeof PartnerRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/resources': typeof ResourcesRoute
  '/security-addendum': typeof SecurityAddendumRoute
  '/stay-in-the-loop': typeof StayInTheLoopRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/landing-pages/$slug': typeof LandingPagesSlugRoute
  '/resources_/$slug': typeof ResourcesSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/about-us'
    | '/acceptable-use-policy'
    | '/cdos'
    | '/ceos'
    | '/cfos'
    | '/contact-sales'
    | '/cookie-policy'
    | '/coos'
    | '/data-processing-addendum'
    | '/data-transfer-addendum'
    | '/evaluation-terms'
    | '/partner'
    | '/privacy-policy'
    | '/resources'
    | '/security-addendum'
    | '/stay-in-the-loop'
    | '/terms-of-service'
    | '/landing-pages/$slug'
    | '/resources/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/about-us'
    | '/acceptable-use-policy'
    | '/cdos'
    | '/ceos'
    | '/cfos'
    | '/contact-sales'
    | '/cookie-policy'
    | '/coos'
    | '/data-processing-addendum'
    | '/data-transfer-addendum'
    | '/evaluation-terms'
    | '/partner'
    | '/privacy-policy'
    | '/resources'
    | '/security-addendum'
    | '/stay-in-the-loop'
    | '/terms-of-service'
    | '/landing-pages/$slug'
    | '/resources/$slug'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/about-us'
    | '/acceptable-use-policy'
    | '/cdos'
    | '/ceos'
    | '/cfos'
    | '/contact-sales'
    | '/cookie-policy'
    | '/coos'
    | '/data-processing-addendum'
    | '/data-transfer-addendum'
    | '/evaluation-terms'
    | '/partner'
    | '/privacy-policy'
    | '/resources'
    | '/security-addendum'
    | '/stay-in-the-loop'
    | '/terms-of-service'
    | '/landing-pages/$slug'
    | '/resources_/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AboutUsRoute: typeof AboutUsRoute
  AcceptableUsePolicyRoute: typeof AcceptableUsePolicyRoute
  CdosRoute: typeof CdosRoute
  CeosRoute: typeof CeosRoute
  CfosRoute: typeof CfosRoute
  ContactSalesRoute: typeof ContactSalesRoute
  CookiePolicyRoute: typeof CookiePolicyRoute
  CoosRoute: typeof CoosRoute
  DataProcessingAddendumRoute: typeof DataProcessingAddendumRoute
  DataTransferAddendumRoute: typeof DataTransferAddendumRoute
  EvaluationTermsRoute: typeof EvaluationTermsRoute
  PartnerRoute: typeof PartnerRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResourcesRoute: typeof ResourcesRoute
  SecurityAddendumRoute: typeof SecurityAddendumRoute
  StayInTheLoopRoute: typeof StayInTheLoopRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  LandingPagesSlugRoute: typeof LandingPagesSlugRoute
  ResourcesSlugRoute: typeof ResourcesSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stay-in-the-loop': {
      id: '/stay-in-the-loop'
      path: '/stay-in-the-loop'
      fullPath: '/stay-in-the-loop'
      preLoaderRoute: typeof StayInTheLoopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security-addendum': {
      id: '/security-addendum'
      path: '/security-addendum'
      fullPath: '/security-addendum'
      preLoaderRoute: typeof SecurityAddendumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner': {
      id: '/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluation-terms': {
      id: '/evaluation-terms'
      path: '/evaluation-terms'
      fullPath: '/evaluation-terms'
      preLoaderRoute: typeof EvaluationTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-transfer-addendum': {
      id: '/data-transfer-addendum'
      path: '/data-transfer-addendum'
      fullPath: '/data-transfer-addendum'
      preLoaderRoute: typeof DataTransferAddendumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-processing-addendum': {
      id: '/data-processing-addendum'
      path: '/data-processing-addendum'
      fullPath: '/data-processing-addendum'
      preLoaderRoute: typeof DataProcessingAddendumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coos': {
      id: '/coos'
      path: '/coos'
      fullPath: '/coos'
      preLoaderRoute: typeof CoosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-sales': {
      id: '/contact-sales'
      path: '/contact-sales'
      fullPath: '/contact-sales'
      preLoaderRoute: typeof ContactSalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cfos': {
      id: '/cfos'
      path: '/cfos'
      fullPath: '/cfos'
      preLoaderRoute: typeof CfosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ceos': {
      id: '/ceos'
      path: '/ceos'
      fullPath: '/ceos'
      preLoaderRoute: typeof CeosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cdos': {
      id: '/cdos'
      path: '/cdos'
      fullPath: '/cdos'
      preLoaderRoute: typeof CdosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/acceptable-use-policy': {
      id: '/acceptable-use-policy'
      path: '/acceptable-use-policy'
      fullPath: '/acceptable-use-policy'
      preLoaderRoute: typeof AcceptableUsePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources_/$slug': {
      id: '/resources_/$slug'
      path: '/resources/$slug'
      fullPath: '/resources/$slug'
      preLoaderRoute: typeof ResourcesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing-pages/$slug': {
      id: '/landing-pages/$slug'
      path: '/landing-pages/$slug'
      fullPath: '/landing-pages/$slug'
      preLoaderRoute: typeof LandingPagesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AboutUsRoute: AboutUsRoute,
  AcceptableUsePolicyRoute: AcceptableUsePolicyRoute,
  CdosRoute: CdosRoute,
  CeosRoute: CeosRoute,
  CfosRoute: CfosRoute,
  ContactSalesRoute: ContactSalesRoute,
  CookiePolicyRoute: CookiePolicyRoute,
  CoosRoute: CoosRoute,
  DataProcessingAddendumRoute: DataProcessingAddendumRoute,
  DataTransferAddendumRoute: DataTransferAddendumRoute,
  EvaluationTermsRoute: EvaluationTermsRoute,
  PartnerRoute: PartnerRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResourcesRoute: ResourcesRoute,
  SecurityAddendumRoute: SecurityAddendumRoute,
  StayInTheLoopRoute: StayInTheLoopRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  LandingPagesSlugRoute: LandingPagesSlugRoute,
  ResourcesSlugRoute: ResourcesSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
